import { render, staticRenderFns } from "./ShareResourcesDialog.vue?vue&type=template&id=88e05968&scoped=true&"
import script from "./ShareResourcesDialog.vue?vue&type=script&lang=js&"
export * from "./ShareResourcesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareResourcesDialog.vue?vue&type=style&index=0&id=88e05968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e05968",
  null
  
)

export default component.exports